import React,{createContext,useContext,useState} from 'react'
const AuthContext=createContext({})

export const useAuth=()=> {
  const context=useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export const AuthProvider=({children})=> {
  const [user,setUser]=useState(null)
  const [loading,setLoading]=useState(false)

  // Mock authentication functions for No Code Backend
  const signUp=async (email,password)=> {
    // This would connect to your No Code Backend
    console.log('Sign up with No Code Backend:',email)
    return {data: null,error: null}
  }

  const signIn=async (email,password)=> {
    // This would connect to your No Code Backend
    console.log('Sign in with No Code Backend:',email)
    // Mock user for demonstration
    setUser({id: 'user-123',email})
    return {data: {user: {id: 'user-123',email}},error: null}
  }

  const signOut=async ()=> {
    setUser(null)
    return {error: null}
  }

  const value={
    user,
    loading,
    signUp,
    signIn,
    signOut,
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}